/**
 * @file 官网首页
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {
    GET_CMSAPI_GETHOMEPAGE,
    GET_USER_LOGINSTATE,
    GET_ARTICLE_LIST,
    GET_NAVIGATION_LIST,
    GET_NAVLIST_INDEX
} from './ActionTypes';

export function fetchCmsapiHomepage(dispatch) {
    return rcAjax('GET', '/cmsapi/getHomepage', {}, {}, data => {
        dispatch({type: GET_CMSAPI_GETHOMEPAGE, data: data.data});
    });
}

export function fetchUserLogin(dispatch) {
    return rcAjax('GET', `/user/loginState?rd=${Math.random()}`, {}, {}, data => {
        dispatch({type: GET_USER_LOGINSTATE, data: data.data});
    });
}

export function fetchArticleList(dispatch) {
    return rcAjax('GET', '/cmsapi/publishArticleList', {catid: 0}, {}, data => {
        dispatch({type: GET_ARTICLE_LIST, data: data.data});
    });
}

export function fetchNavigationList(dispatch) {
    return rcAjax('GET', '/cmsapi/getNavigationList?need_pages=1', {}, {}, data => {
        dispatch({type: GET_NAVIGATION_LIST, data: data.data});
    });
}

export function fetchNavListIndex(dispatch, index) {
    dispatch({type: GET_NAVLIST_INDEX, data: {index: index}});
}


// WEBPACK FOOTER //
// ./src/actions/homeAction.js